import RoomsModel from '../Apis/Rooms'
import Controller from './Controller'

export default class RoomsController extends Controller {
  constructor() {
    super(new RoomsModel())
  }
  async saveRoomsUser(id,params) {
    const data = await this.model.saveRoomsUser(id,params)
    this.Poup(data);
    return data
  }
}
